import React, { useEffect } from 'react'
import { useStyles } from './IdentityValidationStyles'
import { Typography, useMediaQuery, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { UseImage, Buttons, GenericDialog, GenericContainerForm } from '../../components'
import help_INE_frontImg from '../../assets/help_INE_front.png'
import help_INE_backImg from '../../assets/help_INE_back.png'
import helpPassportImg from '../../assets/helpPassport.svg'
import help_front_desktopImg from '../../assets/help_front_desktop.gif'
import help_back_desktopImg from '../../assets/help_back_desktop.gif'
import { t } from 'i18next';

export const HelpDialog = (props) => {
    const windowHeight = window.innerHeight;
    const matches = useMediaQuery('(max-width:812px)')
    const localStyles = useStyles();
    const { t } = useTranslation();

    useEffect(() => {
        if (props.sectionName === 'Anverso') {
            localStorage.setItem('TransactionId', null)
        }
        console.log("props:help: ", props)
    }, []);

    useEffect(() => {
        if (props.sectionName === 'Anverso') {
            localStorage.setItem('TransactionId', null)
        }
    }, [props.sectionName]);

    return (<GenericDialog open={props.open} onClose={props.closeAction}
        // title="Evidencia - Ubicación"
        content={<Box sx={{
            display: 'flex',
            position: 'relative',
            flexDirection: 'column',
            alignItems: "center",
            m: 2.8
        }}>
            <GenericContainerForm sx={(theme) => ({
                width: "80%", [theme.breakpoints.only('xs')]: {
                    width: "100%"
                }
            })}>
                <Typography variant="h6">
                    {GetDataStatusCapture(props.sectionName, props.DocName)}
                </Typography>
                <Typography variant="subtitle" align='justify' >
                    {t("identity_capture")}
                    {GetDataStatusCaptureDescription(props.sectionName, props.DocName)}
                    {/* . Asegúrate de enfocar los datos correctamente, evita sombras y reflejos. */}
                </Typography>
                <ul>
                    <li>
                        <Typography variant="subtitle" style={{ marginTop: '0.5em' }} >{t("identity_capture_message")}</Typography>
                    </li>
                    <li>
                        <Typography variant="subtitle" style={{ marginTop: '0.5em' }} >{t("identity_capture-message_2")}</Typography>
                    </li>
                </ul>
                {matches && (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i)) ?
                    <div style={{
                        marginTop: '40px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        ['@media only screen and (max-width: 812px)']: {
                            height: '30vh',
                            marginTop: '40px',
                        }
                    }}>
                        <UseImage type='Image3' src={
                            (props.sectionName === 'Anverso') ?
                                help_INE_frontImg :
                                (props.sectionName === 'Reverso') ?
                                    help_INE_backImg :
                                    (props.sectionName === 'Anverso' && props.DocName === 'Pasaporte') ?
                                        helpPassportImg : help_INE_backImg
                        }
                            //className={localStyles.imgHelp}
                            width={!matches ? windowHeight > 900 ? 250
                                : windowHeight > 800 ? 250
                                    : 195
                                : windowHeight > 900 ? 260
                                    : windowHeight > 800 ? 250
                                        : windowHeight > 600 ? 180 : 135} />
                    </div>
                    :
                    <div className={localStyles.carouselSection1}>
                        {console.log('props.sectionName', props.sectionName)}
                        <UseImage type='Image3' src={
                            (props.sectionName === 'Anverso') ?
                                help_front_desktopImg :
                                (props.sectionName === 'Reverso') ?
                                    help_back_desktopImg :
                                    (props.sectionName === 'Anverso' && props.DocName === 'Pasaporte') ?
                                        helpPassportImg : help_back_desktopImg
                        } className={localStyles.imgHelp} />
                    </div>
                }
            </GenericContainerForm>
            <Buttons onClickConfirm={props.onCapture} />
        </Box>}
    />)
}

const GetDataStatusCapture = (sectionName, DocName) => {
    if (sectionName === 'Anverso') {
        return t("identity_front", { DocName });
    } else if (sectionName === 'Reverso') {
        return t("identity_back", { DocName });
    } else if (sectionName === 'Anverso' && DocName === 'INE / IFE') {
        return 'Captura el frente de tu identificación (INE/IFE)';
    } else if (sectionName === 'Reverso' && DocName === 'INE / IFE') {
        return 'Capturar la parte trasera de tu identificación (INE/IFE)';
    } else if (sectionName === 'Anverso' && DocName === 'Pasaporte') {
        return 'Captura de pasaporte';
    } else if (sectionName !== undefined && DocName !== undefined &&
        sectionName !== null && DocName !== null &&
        sectionName !== '' && DocName !== '') {
        return `Captura la ${sectionName} de tu ${DocName}`
    }
}

const GetDataStatusCaptureDescription = (sectionName, DocName) => {
    if (sectionName === 'Anverso') {
        return t("identity_front_description", { DocName });
    } else if (sectionName === 'Reverso') {
        return t("identity_back_description", { DocName });
    } else if (sectionName === 'Anverso' && DocName === 'INE / IFE') {
        return 'captura del frente de tu identificación.';
    } else if (sectionName === 'Reverso' && DocName === 'INE / IFE') {
        return 'captura del reverso de tu identificación.';
    } else if (sectionName === 'Anverso' && DocName === 'Pasaporte') {
        return 'captura de tu pasaporte.';
    } else if (sectionName !== undefined && DocName !== undefined &&
        sectionName !== null && DocName !== null &&
        sectionName !== '' && DocName !== '') {
        return `Captura la ${sectionName} de tu ${DocName}`
    }
}